import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-pound-icon',
  templateUrl: './shopping-pound.component.html'
})
export class ShoppingPoundComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
